<div class="container-fluid">
  <!-- Page Title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between" style="background-color: #B71C1C; padding: 1rem; border-radius: 0.375rem; margin-bottom: 1.5rem;">
        <h4 class="mb-sm-0" style="color: white;">
          <i class="ri-team-line me-2"></i>Crew Assignment
        </h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0" style="background-color: transparent; padding: 0;">
            <li class="breadcrumb-item">
              <a href="javascript: void(0);" style="color: rgba(255, 255, 255, 0.8);">Incidents</a>
            </li>
            <li class="breadcrumb-item">
              <a href="/incidents" style="color: rgba(255, 255, 255, 0.8);">List</a>
            </li>
            <li class="breadcrumb-item active" style="color: white;">Crew Assignment</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border" role="status" style="color: #B71C1C;">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading incident and crew data...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="alert alert-danger" role="alert">
    <i class="ri-error-warning-line me-2"></i>
    {{ error }}
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading && !error && incident && roleService.hasRole(['admin', 'fire_station_incharge','fire_station'])">
    <!-- Incident Details -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header" style="background-color: #B71C1C; color: white;">
            <h5 class="card-title mb-0" style="color: white;">
              <i class="ri-file-list-3-line me-2"></i>Incident Details
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <strong>Incident No:</strong> {{ incident.incidentNo || 'N/A' }}
              </div>
              <div class="col-md-3">
                <strong>Type:</strong> {{ incident.incidentType?.name || 'N/A' }}
              </div>
              <div class="col-md-3">
                <strong>Severity:</strong> 
                <span class="badge ms-1" 
                      [style.background-color]="incident.severity?.color || '#6c757d'"
                      style="color: white;">
                  {{ incident.severity?.name || 'N/A' }}
                </span>
              </div>
              <div class="col-md-3">
                <strong>Status:</strong> 
                <span class="badge bg-secondary ms-1">{{ incident.status || 'N/A' }}</span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3">
                <strong>Location:</strong> {{ incident.location || 'N/A' }}
              </div>
              <div class="col-md-3">
                <strong>Contact Person:</strong> {{ incident.contactName || 'N/A' }}
              </div>
              <div class="col-md-3">
                <strong>Contact Number:</strong> {{ incident.contactNumber || 'N/A' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Assigned Vehicles -->
    <div class="row mt-4" >
      <div class="col-12">
        <div class="card">
          <div class="card-header" style="background-color: #B71C1C; color: white;">
            <h5 class="card-title mb-0" style="color: white;">
              <i class="ri-truck-line me-2"></i>Assigned Vehicles
            </h5>
          </div>
          <div class="card-body">
            <div *ngIf="assignedVehicles.length === 0" class="alert alert-warning">
              <i class="ri-alert-line me-2"></i>
              No vehicles have been assigned to this incident yet. Please assign vehicles first.
            </div>
            
            <div *ngIf="assignedVehicles.length > 0" class="row"  >
              <div class="col-md-6 col-lg-4 mb-3" *ngFor="let assignment of assignedVehicles">
                <div class="card h-100">
                  <div class="card-body">
                    <h6 class="card-title">
                      <i class="ri-truck-line me-2"></i>{{ assignment.vehicle?.vehicleNo || assignment.vehicle?.vehicle_number }}
                    </h6>
                    
                    <!-- Vehicle Details -->
                    <div class="row small text-muted mb-2"    >
                      <div class="col-6">
                        <strong>Type:</strong> {{ assignment.vehicle?.vehicleType || assignment.vehicle?.vehicle_type }}
                      </div>
                      <div class="col-6">
                        <strong>Capacity:</strong> {{ assignment.vehicle?.capacity || 'N/A' }}L
                      </div>
                    </div>
                    
                    <div class="row small text-muted mb-2">
                      <div class="col-6">
                        <strong>Make:</strong> {{ assignment.vehicle?.make || 'N/A' }}
                      </div>
                      <div class="col-6">
                        <strong>Model:</strong> {{ assignment.vehicle?.model || 'N/A' }}
                      </div>
                    </div>
                    
                    <!-- Fire Station Info -->
                    <div class="small text-muted mb-2">
                      <i class="ri-building-line me-1"></i>
                      <strong>Fire Station:</strong> {{ assignment.fireStation?.name || 'N/A' }} ({{ assignment.fireStation?.code }})
                    </div>
                    
                    <!-- Assignment Status -->
                    <div class="mb-2">
                      <span class="badge" 
                            [class]="assignment.status === 'assigned' ? 'bg-warning' : 'bg-success'">
                        <i class="ri-flag-line me-1"></i>{{ assignment.status || 'N/A' }}
                      </span>
                      <span class="badge bg-info ms-1" *ngIf="assignment.assignedAt">
                        <i class="ri-time-line me-1"></i>{{ assignment.assignedAt | date:'short' }}
                      </span>
                    </div>
                    
                    <!-- Driver Assignment -->
                    <div class="mt-3">
                      <label class="form-label small fw-bold">Assign Driver:</label>
                      <select class="form-select form-select-sm" 
                              (change)="onDriverAssignmentChange(assignment.id, $any($event.target).value)"
                              [disabled]="assignment.driver">
                        <option value="">Select Driver</option>
                        <option *ngFor="let driver of availableDrivers" 
                                [value]="driver.id"
                                [selected]="assignment.driverUserId === driver.id">
                          {{ driver.fullName}}
                        </option>
                      </select>
                      
                      <!-- Show currently assigned driver -->
                      <div class="small text-muted mt-1" *ngIf="assignment.driver">
                        <i class="ri-user-line me-1"></i>
                        Currently: {{ assignment.driver.fullName }}
                      </div>
                    </div>

                    <!-- Vehicle Change Button -->
                    <div class="mt-3">
                      <button type="button" 
                              class="btn btn-sm btn-outline-primary w-100"
                              (click)="toggleVehicleChange(assignment.id)">
                        <i class="ri-refresh-line me-1"></i>
                        {{ showVehicleChangeFor == assignment.id ? 'Cancel Change' : 'Change Vehicle' }}
                      </button>
                    </div>

                    <!-- Vehicle Change Dropdown (shown when button clicked) -->
                    <div class="mt-3" *ngIf="showVehicleChangeFor == assignment.id">
                      <label class="form-label small fw-bold">Select New Vehicle:</label>
                      <select class="form-select form-select-sm" 
                              (change)="onVehicleChange(assignment.id, $any($event.target).value)">
                        <option value="">Select Vehicle</option>
                        <option *ngFor="let vehicle of availableVehicles" 
                                [value]="vehicle.id">
                          {{ vehicle.vehicleNo }} - {{ vehicle.vehicleType }} ({{ vehicle.fireStation?.name }})
                        </option>
                      </select>
                      <div class="small text-muted mt-1">
                        <i class="ri-information-line me-1"></i>
                        Select a new vehicle to replace the current one
                      </div>
                    </div>
                    
                    <!-- Assignment Details -->
                    <div class="mt-2 small text-muted" *ngIf="assignment.remarks">
                      <i class="ri-message-3-line me-1"></i>
                      {{ assignment.remarks }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Crew Assignment -->
    <div class="row mt-4" *ngIf="assignedVehicles.length > 0 && roleService.hasRole(['fire_station_incharge','fire_station'])">
      <ng-container *ngIf="!incident.hasPendingAdditionalRequests">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" style="background-color: #B71C1C; color: white;">
            <h6 class="card-title mb-0" style="color: white;">
              <i class="ri-user-star-line me-2"></i>Crew Incharge
            </h6>
          </div>
          <div class="card-body">
            <select class="form-select" (change)="onCrewInchargeChange($any($event.target).value)">
              <option value="">Select Crew Incharge</option>
              <option *ngFor="let crew of availableCrew" 
                      [value]="crew.id">
                {{ crew.fullName }} - {{ crew.rank || crew.position }}
              </option>
            </select>
          </div>
        </div>
      </div>
      </ng-container>
      
      <div class="col-md-6" *ngIf="roleService.hasRole(['fire_station_incharge','fire_station'])">
        <div class="card">
          <div class="card-header" style="background-color: #B71C1C; color: white;">
            <h6 class="card-title mb-0" style="color: white;">
              <i class="ri-group-line me-2"></i>Crew Members
            </h6>
          </div>
          <div class="card-body">
            <div class="row" style="max-height: 200px; overflow-y: auto;">
              <div class="col-12" *ngFor="let crew of availableCrew">
                <div class="form-check" style="margin-left: 15px;">
                  <input class="form-check-input" 
                         type="checkbox" 
                         [id]="'crew-' + crew.id"
                         [value]="crew.id"
                         (change)="onCrewMemberToggle(crew.id, $event)">
                  <label class="form-check-label" [for]="'crew-' + crew.id">
                    {{ crew.fullName }} - {{ crew.rank || crew.position }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="row mt-4" *ngIf="assignedVehicles.length > 0 && !incident.crewInchargeUserId">
      <div class="col-12">
        <div class="d-flex gap-2 justify-content-end">
          <button type="button" class="btn btn-secondary" (click)="goBack()">
            <i class="ri-arrow-left-line me-1"></i>Back to List
          </button>
          <button type="button" 
                  class="btn btn-primary" 
                  (click)="submitCrewAssignment()"
                  [disabled]="submitting || !crewInchargeUserId"
                  style="background-color: #B71C1C; border-color: #B71C1C;">
            <i class="ri-check-line me-1" *ngIf="!submitting"></i>
            <span class="spinner-border spinner-border-sm me-1" *ngIf="submitting"></span>
            {{ submitting ? 'Assigning...' : 'Assign Crew' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Shift Change Button -->
    <div class="row mt-4" *ngIf="incident.crewInchargeUserId && incident.status !== 'completed' && roleService.hasRole(['admin', 'fire_station_incharge','fire_station'])">
      <div class="col-12">
        <button type="button" 
                class="btn btn-warning" 
                (click)="openShiftChangeModal(shiftChangeModal)">
          <i class="ri-refresh-line me-1"></i>
          Relieve and Reassign (Shift Change)
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Shift Change Modal -->
<ng-template #shiftChangeModal let-modal>
  <div class="modal-header" style="background-color: #FF9800; color: white;">
    <h5 class="modal-title">
      <i class="ri-refresh-line me-2"></i>Relieve and Reassign (Shift Change)
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
        <!-- Crew Incharge and Members -->
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card">
              <div class="card-header" style="background-color: #B71C1C; color: white;">
                <h6 class="card-title mb-0" style="color: white;">
                  <i class="ri-user-star-line me-2"></i>New Crew Incharge
                </h6>
              </div>
              <div class="card-body">
                <select class="form-select" (change)="onShiftCrewInchargeChange($any($event.target).value)">
                  <option value="">Select Crew Incharge</option>
                  <option *ngFor="let crew of availableCrew" 
                          [value]="crew.id">
                    {{ crew.fullName }} - {{ crew.rank || crew.position }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card">
              <div class="card-header" style="background-color: #B71C1C; color: white;">
                <h6 class="card-title mb-0" style="color: white;">
                  <i class="ri-group-line me-2"></i>New Crew Members
                </h6>
              </div>
              <div class="card-body">
                <div class="row" style="max-height: 200px; overflow-y: auto;">
                  <div class="col-12" *ngFor="let crew of availableCrew">
                    <div class="form-check" style="margin-left: 15px;">
                      <input class="form-check-input" 
                             type="checkbox" 
                             [id]="'shift_crew_modal_' + crew.id"
                             [value]="crew.id"
                             (change)="onShiftCrewMemberToggle(crew.id, $event)">
                      <label class="form-check-label" [for]="'shift_crew_modal_' + crew.id">
                        {{ crew.fullName }} - {{ crew.rank || crew.position }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Driver Reassignments -->
        <div class="row" *ngIf="assignedVehicles.length > 0">
          <div class="col-12 mb-3">
            <div class="card">
              <div class="card-header" style="background-color: #B71C1C; color: white;">
                <h5 class="card-title mb-0" style="color: white;">
                  <i class="ri-steering-2-line me-2"></i>Reassign Drivers
                </h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 col-lg-4 mb-3" *ngFor="let assignment of assignedVehicles">
                    <div class="card h-100">
                      <div class="card-body">
                        <h6 class="card-title">
                          <i class="ri-truck-line me-2"></i>{{ assignment.vehicle?.vehicleNo || assignment.vehicle?.vehicle_number }}
                        </h6>
                        
                        <!-- Vehicle Details -->
                        <div class="row small text-muted mb-2">
                          <div class="col-6">
                            <strong>Type:</strong> {{ assignment.vehicle?.vehicleType || assignment.vehicle?.vehicle_type }}
                          </div>
                          <div class="col-6">
                            <strong>Capacity:</strong> {{ assignment.vehicle?.capacity || 'N/A' }}L
                          </div>
                        </div>
                        
                        <div class="row small text-muted mb-2">
                          <div class="col-6">
                            <strong>Make:</strong> {{ assignment.vehicle?.make || 'N/A' }}
                          </div>
                          <div class="col-6">
                            <strong>Model:</strong> {{ assignment.vehicle?.model || 'N/A' }}
                          </div>
                        </div>
                        
                        <!-- Fire Station Info -->
                        <div class="small text-muted mb-2">
                          <i class="ri-building-line me-1"></i>
                          <strong>Fire Station:</strong> {{ assignment.fireStation?.name || 'N/A' }} ({{ assignment.fireStation?.code }})
                        </div>
                        
                        <!-- Assignment Status -->
                        <div class="mb-2">
                          <span class="badge" 
                                [class]="assignment.status === 'assigned' ? 'bg-warning' : 'bg-success'">
                            <i class="ri-flag-line me-1"></i>{{ assignment.status || 'N/A' }}
                          </span>
                          <span class="badge bg-info ms-1" *ngIf="assignment.assignedAt">
                            <i class="ri-time-line me-1"></i>{{ assignment.assignedAt | date:'short' }}
                          </span>
                        </div>
                        
                        <!-- Driver Assignment -->
                        <div class="mt-3">
                          <label class="form-label small fw-bold">Assign Driver:</label>
                          <select class="form-select form-select-sm" 
                                  (change)="onShiftDriverAssignmentChange(assignment.id, $any($event.target).value)">
                            <option value="">Select Driver</option>
                            <option *ngFor="let driver of availableDrivers" 
                                    [value]="driver.id"
                                    [selected]="shiftChangeDriverAssignments[assignment.id] === driver.id">
                              {{ driver.fullName}}
                            </option>
                          </select>
                          
                          <!-- Show currently assigned driver -->
                          <div class="small text-muted mt-1" *ngIf="assignment.driver">
                            <i class="ri-user-line me-1"></i>
                            Currently: {{ assignment.driver.fullName }}
                          </div>
                        </div>
                        
                        <!-- Assignment Details -->
                        <div class="mt-2 small text-muted" *ngIf="assignment.remarks">
                          <i class="ri-message-3-line me-1"></i>
                          {{ assignment.remarks }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Remarks -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <label class="form-label fw-bold">Remarks:</label>
                <input type="text" 
                       class="form-control" 
                       [(ngModel)]="shiftChangeRemarks" 
                       name="shiftChangeRemarks" 
                       placeholder="e.g., Morning shift handover">
              </div>
            </div>
          </div>
        </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      <i class="ri-close-line me-1"></i>Cancel
    </button>
    <button type="button" 
            class="btn btn-primary" 
            (click)="submitShiftChange()"
            [disabled]="isSubmittingShiftChange"
            style="background-color: #B71C1C; border-color: #B71C1C;">
      <i class="ri-refresh-line me-1" *ngIf="!isSubmittingShiftChange"></i>
      <span class="spinner-border spinner-border-sm me-1" *ngIf="isSubmittingShiftChange"></span>
      {{ isSubmittingShiftChange ? 'Processing...' : 'Complete Shift Change' }}
    </button>
  </div>
</ng-template>
